<template>
  <div>
    <h3>{{ this.isAddMode ? "Opret" : "Rediger" }} Standardpakke</h3>

    <vx-card no-shadow class="mt-8">

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Standardpakke navn</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            class="w-full"
            v-model="hardware.name"
            placeholder="Titel..."
            :disabled="!this.isAddMode"
          />
        </div>
      </div>

      <br />
      <vs-divider></vs-divider>
      <br />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Hardware</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-button
            @click="showHardwareOptionsPopup = true"
            id="add-ad-group-button"
            color="success"
            class="ml-auto mr-auto"
            >Tilføj hardware til Standardpakke</vs-button
          >
        </div>
      </div>

      <vs-popup title="Hardware" :active.sync="showHardwareOptionsPopup">
        <div>
          <vs-table
            multiple
            v-model="selectedHardware"
            pagination
            max-items="13"
            search
            :data="hardwareOptions"
          >
            <template slot="thead">
              <vs-th sort-key="displayName">
                Navn
              </vs-th>
              <vs-th sort-key="thead">
                Pris
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].navn">
                  {{ data[indextr].navn }}
                </vs-td>
                <vs-td :data="data[indextr].pris">
                  {{ data[indextr].pris }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-popup>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-chip
            v-for="(hardwareOption, key) in selectedHardware"
            :key="hardwareOption.id"
            @click="$delete(selectedHardware, key)"
            closable
          >
            {{ hardwareOption.navn }}
          </vs-chip>
        </div>
      </div>
    </vx-card>

    <!-- Register Hardware Template Button -->
    <div class="flex flex-wrap items-center justify-end mt-12">
      <backbutton></backbutton>
      <vs-button
        @click="saveData"
        id="save-button"
        class="ml-4 mr-auto mt-2"
        >{{ this.isAddMode ? "Opret" : "Opdater" }}</vs-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hardwareId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hardware: {
        name: "",    
        indhold: [],
      },
      selectedHardware: [],

      showHardwareOptionsPopup: false,
      hardwareOptions : [],
      
      query: "*"
    };
  },
  computed: {
    isAddMode() {
      return !this.hardwareId;
    }
  },
  methods: {
    getHardwareOptions: function() {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/HardwareOptions?query=" + this.query)
        .then(resp => {
          this.hardwareOptions = resp.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    saveData: function() {
      this.$vs.loading();

      const payload = {
        name: this.hardware.name,
        indhold: this.selectedHardware.map(x => x.navn + " ( " + x.pris + " )"),
      }

      if (this.hardwareId) {
        this.updateHardware(payload);
      } else {
        this.registerHardware(payload);
      }
    },
    updateHardware(payload) {
      this.$http
        .put(
          process.env.VUE_APP_API +
            "/Hardware/" +
            this.hardwareId,
          payload
        )
        .then(resp => {
          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Standardpakke opdateret"
            });

            this.$router.push({ name: "hardwares" }).catch(() => {});
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text:
                "Standardpakke kunne ikke opdateres: " + resp.data.error
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    registerHardware(payload) {
      this.$http
        .post(process.env.VUE_APP_API + "/Hardware", payload)
        .then(resp => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Standardpakke registered"
          });

          console.log(
            "Standardpakke registered:",
            resp.data.hardwareId
          );

          this.$router.push({ name: "hardwares" }).catch(() => {});
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getHardwareTemplate: function() {
      this.$vs.loading();

      this.$http
        .get(
          process.env.VUE_APP_API +
            "/Hardware/" +
            this.hardwareId
        )
        .then(resp => {
          this.hardware = resp.data;
          this.hardware.indhold = resp.data.indhold;
          this.getHardwareOptionsById(this.hardware.indhold);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getHardwareOptionsById(indhold) {
      try {
        var result = [];
        this.$vs.loading();
        indhold.forEach(hardwareOption => {
          var item = hardwareOption.split("( ");
          //console.log(hardwareOption);
          this.$http
            .get(process.env.VUE_APP_API + "/HardwareOptions?query=" + item[0])
            .then(resp => {
              //console.log(resp);
              result.push({
                id: resp.data[0].id,
                navn: resp.data[0].navn,
                pris: resp.data[0].pris
              });
            });
        });
      } catch (error) {
        console.log(error);
      }
      this.selectedHardware = result;
      this.$vs.loading.close();
    }
  },
  created() {
    this.getHardwareOptions();
    if (!this.isAddMode) {
      this.getHardwareTemplate();
      this.getHardwareOptionsById(this.hardware.indhold);
    }else{
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/Hardware/" + this.hardwareId)
        .then(resp => {
          this.hardware = resp.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }

  }
};
</script>

<style lang="scss" scoped>
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
select {
  height: 40px;
  padding: 10px;
  border-color: lightgrey;
  border-radius: 5px;
  color: #626262;
}
.selector {
  width: 40% !important;
}
.selector select {
  width: 100% !important;
}
.firstRadio {
  padding-right: 2em;
}
</style>
